import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { CommonService } from 'src/app/shared/services/common.service';
import { constants } from 'src/app/shared/common/contants';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { ExceptionQueryComponent } from '../exception-query.component';
import {  ElementRef, ViewChild } from '@angular/core';
import { SqlEditorPopupComponent } from '../../attribute-mapping-config/sql-editor-popup/sql-editor-popup.component';
import { CommonPopupSearchComponent } from '../../common-popup-search/common-popup-search.component';
import { EtlService } from '../../vault-data-migration-etl/etl.service';
import { FieldMappingService } from 'src/app/shared/services/field-mapping.service';

export interface exceptionQueryEditData{
   editData: any;
}

@Component({
    selector: 'app-exception-query-popup',
    templateUrl: './exception-query-popup.component.html',
    styleUrls: ['./exception-query-popup.component.scss'],
    standalone: false
})



export class ExceptionQueryPopupComponent implements OnInit {



      @ViewChild('codeEditor') codeEditor!: ElementRef;
      @ViewChild('codeExceptionEditor') codeExceptionEditor!: ElementRef;
      @ViewChild('freetextEditor') freetextEditor!: ElementRef;
      expressionDetails: string = '';
      freetextDetails : string = '';
      exceptionExpressionDetails: string = '';
      editData: any = null;

    backgroundColorButton;
    FormValid: UntypedFormGroup;
    updatedData;
    uploadId;
    name;
    validation_messages: any;
    mappingtypename
    buttonName
    idColumn
    formValidCheckbox: UntypedFormGroup;
    isCheckboxSelected=false;
    showCreateAnother=true;
  buttonColor;
    validations_form: UntypedFormGroup;
  mappingConfigurationData:any=[]
  selectedReferenceSourceObjectsListNames;
  selectedReferenceTargetObjectsListNames;
  selectedObjectMappingOrdeId;
  // selectedReferenceLibraryObjectsListNames: any;
  
  selectedReferenceLibraryObjectsListNames;
  selectedGlobalExternalObjectsListNames: any;
  selectedStageObject=[];
    selectedReferenceValueMapping=[];
      selectedReferenceGlobalObjectsListNames;
        codeListData;
  selectedReferenceGlobalSourceObjectsListNames;
    selectedSourceAttributeList=[];
SourceId;
referenceLibraryObjectsLookupValue;
referenceGlobalObjectsLookupValue;
targetdnsid;
  ObjectsData;
    codeListNamesDistinctData=[];
      codeListNameHeaders=[];
      defult:any = [];
referenceSourceObjectsList: any[] = [];
referenceTargetObjectsList: any[] = [];
  referenceLibraryObjectsList;
referenceGlobalObjectsList: any[] = [];
referenceSourceGlobalObjectsList: any[] = [];
referenceExternalObjectsList: any[] = [];
selectedReferenceSourceObjectsList: any[] = [];
selectedReferenceTargetObjectsList: any[] = [];
selectedReferenceLibraryObjectsList: any[] = [];
selectedReferenceGlobalObjectsList: any[] = [];
selectedReferenceGlobalSourceObjectsList: any[] = [];
selectedGlobalExternalObjectsList: any[] = [];

   constructor(private localStorageSettings: LocalStorageSettingsService, @Inject(MAT_DIALOG_DATA) public data: exceptionQueryEditData,
     private valueMappingservice:FieldMappingService,private commonService:CommonService, private etlservice:EtlService,
    public dialogRef:MatDialogRef<ExceptionQueryPopupComponent>,  private dialog: MatDialog,private validation:validationmethod,private localstorage:LocalStorageSettingsService,
      private errormessage:ErrorMessages,private spinner: NgxUiLoaderService,private snackbar:MatSnackBar, private constants:constants,private fb: UntypedFormBuilder
    ) { }

  ngOnInit(): void {

      this.buttonName = 'Save'
      
      this.backgroundColorButton = this.localstorage.getSettings('ColorA');
     
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
      this.formValidations();
      this.formValidationsCheckbox();

      this.editData=this.data.editData;
  console.log("EDIT DATA:", this.editData);

 
  this.buttonName = this.editData ? "Update" : "Save";
   this.showCreateAnother = this.buttonName === 'Save';
 
  // this.SourceId = this.editData?.sourceId || null;
  // this.targetdnsid = this.editData?.targetId || null;
 
  this.retrieveSourceAndTarget();

    if (this.editData) {
    this.populateEditData(this.editData);
  }
    }

     formValidations() {
       this.validations_form = new UntypedFormGroup({
    orderId: new UntypedFormControl('',[Validators.required,Validators.min(1)]),
    exceptionType: new UntypedFormControl('', Validators.required),
    executionType: new UntypedFormControl('', Validators.required),

    selectedReferenceSourceObjectsListNamesForm: new UntypedFormControl(''),
    selectedReferenceTargetObjectsListNamesForm: new UntypedFormControl(''),
    selectedReferenceValueMappingForm: new UntypedFormControl([]),
    selectedReferenceLibraryForm: new UntypedFormControl(''),
    selectedReferenceGlobalObjectsListNamesForm: new UntypedFormControl(''),
    selectedReferenceGlobalSourceObjectsListNamesForm: new UntypedFormControl(''),
    selectedGlobalExternalObjectsListNamesForm: new UntypedFormControl(''),

    exceptionQuery: new UntypedFormControl('') 
        });
     }


    ngAfterViewInit() {
  // Initialize with delay to ensure DOM is ready
  setTimeout(() => {
    this.initializeCodeMirrorEditors();
  }, 0);
}

initializeCodeMirrorEditors() {
  
}
     
    

    searchableReferenceSourceObjects(){
         if(this.referenceSourceObjectsList.length > 0){
                var columndata = []
              var c = {
                "objectlabel": "Object Label",
                "objectname":"Object Name"
              } 
             columndata.push(c)
             let selectedList=[];
             if(this.selectedReferenceSourceObjectsList.length >0){
                selectedList = this.selectedReferenceSourceObjectsList;
             }
              let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
                width: "50%",
                autoFocus: false,
                disableClose: true,
                data: { 
                  edata:this.referenceSourceObjectsList,
                  page:"multiple",
                  columns:columndata,
                  selectedValue:selectedList,
                  selectedPropertyName:"objectname"
                }
              });
               dialogRef.afterClosed().subscribe(result => {
              console.log(result);
              if (result != undefined) {
                console.log(result.selectedRows);
                this.selectedReferenceSourceObjectsList=result.selectedRows.map((item: any) => item.objectname);
               this.selectedReferenceSourceObjectsListNames =result.selectedRows.map(item => item.objectname).join(',');
              }
              })
            }
      }


       getSourceReferenceObjects(){
     this.spinner.start();
      this.commonService.retrieveObjectGroupObjectsbasedDns(this.SourceId).subscribe(res=>{
            if (res.error === true) {
                // this.ObjectGrid.api.setGridOption('rowData', []);
            } else {
               
                console.log(res);
                const objects = res.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
               
                this.referenceSourceObjectsList = objects;
                 this.commonService.getlookupVauleByLookUpType("Vault Object Group").subscribe(result => {
                  console.log(result);
                 let lookupDetails:any=result
                  let ExternalLookupValue=lookupDetails.filter(item=>item.lookupcode=="External")
                  this.referenceLibraryObjectsLookupValue=lookupDetails.filter(item=>item.lookupcode=="Library");
                  this.referenceGlobalObjectsLookupValue=lookupDetails.filter(item=>item.lookupcode=="Global");
                  console.log(ExternalLookupValue);
                  let lookupValueId=ExternalLookupValue[0].lookupvalueid
                  const externalObjects = res.filter(item=>item.objecttype == lookupValueId);
                  console.log(externalObjects);
                  console.log("*****************************");
                  
                   this.referenceExternalObjectsList=externalObjects.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
                let globalLookupId=this.referenceGlobalObjectsLookupValue[0].lookupvalueid
                const globalObjects=res.filter(item=>item.objecttype == globalLookupId);
                this.referenceSourceGlobalObjectsList=globalObjects.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
                 })
                this.getTargetReferenceObjects();
            }
            
    })
  }

   getTargetReferenceObjects(){

        this.commonService.retrieveNonStageObjectsbasedDns(this.targetdnsid).subscribe(res=>{
            if (res.error === true) {
                // this.ObjectGrid.api.setGridOption('rowData', []);
                 this.spinner.stop();
            } else {
              
                console.log(res);
                const objects = res.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
                  this.referenceTargetObjectsList = objects;
                  let lookupValueId=this.referenceLibraryObjectsLookupValue[0].lookupvalueid
                  const LibraryObjects = res.filter(item=>item.objecttype == lookupValueId);
                  
                   this.referenceLibraryObjectsList=LibraryObjects.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
                console.log(this.referenceLibraryObjectsList);

                 let globalLookupValueId=this.referenceGlobalObjectsLookupValue[0].lookupvalueid
                  const GlobalObjects = res.filter(item=>item.objecttype == globalLookupValueId);
                  
                   this.referenceGlobalObjectsList=GlobalObjects.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
                   this.spinner.stop();
            }
            
    });
  }

  
retrieveSourceAndTarget() {
  const dnsId =  this.localStorageSettings.getSettings("WorkspaceId")
  this.spinner.start();
  this.etlservice.retrieveSourceAndTraget(dnsId, "Source").subscribe({
    next: (result) => {
      console.log(result);
      if (result === null) {
        console.log("No Data Found");
      } else {
        this.SourceId = result.sourceId
         this.targetdnsid = result.targetId
      }
      this.getSourceReferenceObjects();  
       this.retrieveMappingDetails(dnsId)
    },
    error: (err) => {
       this.retrieveMappingDetails(dnsId)
      console.error("Error snapshotDetails:", err);
      // this.spinner.stop();
    }
  });
}


  retrieveMappingDetails(dnsid){
    this.commonService.retrieveMappingConfiguration().subscribe(response => {
      // this.spinner.start();
      console.log(response);
      // checking if response is true or not
      if (response.error == true) {
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        
        this.retrieveMappingTypes()
        // this.spinner.stop();
      } else {
        console.log(response)
        this.mappingConfigurationData=response;
        if(this.mappingConfigurationData.length > 0){
        this.mappingConfigurationData=this.mappingConfigurationData.map(obj => ({
          ...obj,
          combined: `${obj.stageobject}_${obj.targetobject}`
        }));
        }
        this.retrieveMappingTypes()
        // this.spinner.stop();
      }
      
    });
  }


  //============================================
   retrieveMappingTypes(){
    // this.spinner.start();
    let dnsId = this.localStorageSettings.getSettings("dnsName");
    this.valueMappingservice.retreiveMappingTypes(dnsId).subscribe(response=>{
      if(response.error == true){
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", { 
          duration: 5000,
        });
        
         this.getCompleteObjectsData();
      }else{
        
        console.log(response);
        this.codeListData=response;
        if( this.codeListData.length > 0){
        
        
        let codeListMappingId =  this.codeListData.filter(item=>item.mappingTypeName == "Codelist_Mapping")
        console.log(codeListMappingId);
        
        this.getCodeListMappingDetails(codeListMappingId[0].mappingTypeId)
      }
         this.getCompleteObjectsData();
        // this.spinner.stop();
      }
    })
  }

  getCompleteObjectsData(){
  this.spinner.start();
    this.commonService.retrieveObjectGroupObjectsbasedDns(this.SourceId).subscribe(response=>{
      if(response.error == true){
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
      }else{
       this.ObjectsData = response;
        this.spinner.stop();
      }
    })
}
   getCodeListMappingDetails(CodeListMappingId){
  this.valueMappingservice.retreiveFieldMapping(CodeListMappingId).subscribe(response=>{
            if(response.error == true){
               this.spinner.stop();
            }else{
              let getdata:any=response
              let data:any = JSON.parse(getdata.mappedFieldsData)
              console.log(data);
              let headers=JSON.parse(getdata.mappedFields)
              let codeListData=[]
              codeListData.push(...headers.SourceColumns)
              codeListData.push(...headers.TargetColumns)
              console.log(headers);
              
              console.log(codeListData);
              const distinctCodelistNames = Array.from(
  new Set(data.map(item => item.CODELIST_NAME))
).map(name => ({ CODELIST_NAME: name }));
              console.log(distinctCodelistNames);
              this.codeListNamesDistinctData=distinctCodelistNames;
              this.codeListNameHeaders=codeListData;
              // if(headers){
              //   console.log(headers);
              //   this.valueMappingHeaders=[]
              //   this.valueMappingHeaders.push(...headers.SourceColumns)
              //   this.valueMappingHeaders.push(...headers.TargetColumns)
              //   // this.headersDataDetails=headers
              //   console.log(this.valueMappingHeaders);
              //    this.selectedStageObjectAttributesList=this.valueMappingHeaders
              // }
               this.spinner.stop();
            }
          })
 }

       searchableReferenceTargetObjects(){
           if(this.mappingConfigurationData.length > 0){
      //  let filteredObjectMappingBasedOnOrderIdList = this.mappingConfigurationData.filter(item =>
      //       item.orderId !== null && item.orderId < this.selectedObjectMappingOrdeId
      //     ).sort((a, b) => a.orderId - b.orderId);

      let filteredObjectMappingBasedOnOrderIdList =
  this.mappingConfigurationData.sort((a, b) => a.orderId - b.orderId);
      
          console.log(filteredObjectMappingBasedOnOrderIdList);
          
                  var columndata = []
                var c = {
                  "orderId":"Order Id",
                   "combined": "Reference Transform",
                } 
               columndata.push(c)
               let selectedList=[]
               if(this.selectedReferenceTargetObjectsList.length > 0){
                for(let i=0;i<this.selectedReferenceTargetObjectsList.length;i++){
                  let subObjects=this.selectedReferenceTargetObjectsList[i].split("--")
                  let objects={
                    "stageobject":subObjects[0],
                    "targetobject":subObjects[1]
                  }
                   selectedList.push(objects)
                }
               
               }
               console.log(selectedList);
               
                let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
                  width: "50%",
                  autoFocus: false,
                  disableClose: true,
                  data: { 
                    edata:filteredObjectMappingBasedOnOrderIdList,
                    page:"multiple",
                    columns:columndata,
                    selectedValue:selectedList,
                    selectedPropertyName:"stageobject"
                  }
                });
                 dialogRef.afterClosed().subscribe(result => {
                console.log(result);
                if (result != undefined) {
                  console.log(result.selectedRows);
                  this.selectedReferenceTargetObjectsList=result.selectedRows.map((item: any) => item.stageobject+"--"+item.targetobject)
                 this.selectedReferenceTargetObjectsListNames = result.selectedRows.map(item => item.stageobject+"--"+item.targetobject).join(',');
                   console.log();
                                                            
                }
                })
              }
        }


           searchableReferenceLibraryObjects(){
             if(this.referenceLibraryObjectsList.length > 0){
                    var columndata = []
                  var c = {
                     "objectlabel": "Object Label",
                    "objectname":"Object Name"
                  } 
                 columndata.push(c)
                 let selectedList=[]
                 if(this.selectedReferenceLibraryObjectsList.length > 0){
                  selectedList=this.selectedReferenceLibraryObjectsList;
                 }
                  let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
                    width: "50%",
                    autoFocus: false,
                    disableClose: true,
                    data: { 
                      edata:this.referenceLibraryObjectsList,
                      page:"multiple",
                      columns:columndata,
                      selectedValue:selectedList,
                      selectedPropertyName:"objectname"
                    }
                  });
                   dialogRef.afterClosed().subscribe(result => {
                  console.log(result);
                  if (result != undefined) {
                    console.log(result.selectedRows);
                    this.selectedReferenceLibraryObjectsList=result.selectedRows.map((item: any) => item.objectname)
                   this.selectedReferenceLibraryObjectsListNames = result.selectedRows.map(item => item.objectname).join(',');
                     console.log();
                                                              
                  }
                  })
                }
          }

           searchableGlobalExternalObjects(){
            if (!this.referenceExternalObjectsList) {
    console.warn("referenceExternalObjectsList not loaded yet");
    this.snackbar.open("External objects not loaded yet.", "OK", { duration: 3000 });
    return;
  }

  if (this.referenceExternalObjectsList.length === 0) {
    this.snackbar.open("No external objects available.", "OK", { duration: 3000 });
    return;
  }
               if (this.referenceExternalObjectsList.length > 0) {

                      var columndata = []
                    var c = {
                      "objectlabel": "Object Label",
                      "objectname":"Object Name"
                    } 
                   columndata.push(c)
                   let selectedList=[];
                   if(this.selectedGlobalExternalObjectsList.length >0){
                      selectedList = this.selectedGlobalExternalObjectsList;
                   }
                    let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
                      width: "50%",
                      autoFocus: false,
                      disableClose: true,
                      data: { 
                        edata:this.referenceExternalObjectsList,
                        page:"multiple",
                        columns:columndata,
                        selectedValue:selectedList,
                        selectedPropertyName:"objectname"
                      }
                    });
                     dialogRef.afterClosed().subscribe(result => {
                    console.log(result);
                    if (result != undefined) {
                      console.log(result.selectedRows);
                      this.selectedGlobalExternalObjectsList=result.selectedRows.map((item: any) => item.objectname);
                     this.selectedGlobalExternalObjectsListNames =result.selectedRows.map(item => item.objectname).join(',');
                    }
                    })
                  }
            }
            

              searchableReferenceGlobalObjects(){
                 if(this.referenceGlobalObjectsList.length > 0){
                        var columndata = []
                      var c = {
                        "objectlabel": "Object Label",
                        "objectname":"Object Name"
                      } 
                     columndata.push(c)
                     let selectedList=[];
                     if(this.selectedReferenceGlobalObjectsList.length >0){
                        selectedList = this.selectedReferenceGlobalObjectsList;
                     }
                      let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
                        width: "50%",
                        autoFocus: false,
                        disableClose: true,
                        data: { 
                          edata:this.referenceGlobalObjectsList,
                          page:"multiple",
                          columns:columndata,
                          selectedValue:selectedList,
                          selectedPropertyName:"objectname"
                        }
                      });
                       dialogRef.afterClosed().subscribe(result => {
                      console.log(result);
                      if (result != undefined) {
                        console.log(result.selectedRows);
                        this.selectedReferenceGlobalObjectsList=result.selectedRows.map((item: any) => item.objectname);
                       this.selectedReferenceGlobalObjectsListNames =result.selectedRows.map(item => item.objectname).join(',');
                      }
                      })
                    }
              }


                searchableReferenceGlobalSourceObjects(){
                   if(this.referenceSourceGlobalObjectsList.length > 0){
                          var columndata = []
                        var c = {
                          "objectlabel": "Object Label",
                          "objectname":"Object Name"
                        } 
                       columndata.push(c)
                       let selectedList=[];
                       if(this.selectedReferenceGlobalSourceObjectsList.length >0){
                          selectedList = this.selectedReferenceGlobalSourceObjectsList;
                       }
                        let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
                          width: "50%",
                          autoFocus: false,
                          disableClose: true,
                          data: { 
                            edata:this.referenceSourceGlobalObjectsList,
                            page:"multiple",
                            columns:columndata,
                            selectedValue:selectedList,
                            selectedPropertyName:"objectname"
                          }
                        });
                         dialogRef.afterClosed().subscribe(result => {
                        console.log(result);
                        if (result != undefined) {
                          console.log(result.selectedRows);
                          this.selectedReferenceGlobalSourceObjectsList=result.selectedRows.map((item: any) => item.objectname);
                         this.selectedReferenceGlobalSourceObjectsListNames =result.selectedRows.map(item => item.objectname).join(',');
                        }
                        })
                      }
                }

            openSqlBuilderPopUpForException(){
              let dialogRef = this.dialog.open(SqlEditorPopupComponent, { 
                     width: "90%",
                     autoFocus: false,
                     maxWidth: '100vw',
                     height: "95%",
                     disableClose: true,
                     data: { objectList: this.selectedStageObject },
                   });
                   dialogRef.afterClosed().subscribe(result => {
                     console.log(result);
                    //  this.editor.setValue(result);
                     this.exceptionExpressionDetails = result;
                   })  
             }
            
      
    cancel(){
      this.dialogRef.close();
    }
  
     formValidationsCheckbox() {
  this.formValidCheckbox = new UntypedFormGroup({
    isCheckboxSelected: new UntypedFormControl(false)
  });
}

  
    saveMethod(){

      console.log('Save method called');

    if (this.validations_form.invalid) {
  this.validation.validateAllFormFields(this.validations_form);
    this.snackbar.open("All mandatory fields to be filled", "OK", { duration: 4000 });
    return;
  }

   let requestData: any = {
    orderId: this.validations_form.value.orderId,
    exceptionType: this.validations_form.value.exceptionType,
    executionType: this.validations_form.value.executionType,
    referenceSourceObject: this.selectedReferenceSourceObjectsListNames,
    referenceTransform: this.selectedReferenceTargetObjectsListNames,
    referenceValueMapping: this.selectedReferenceValueMapping?.join(','),
    referenceLibraryObjects: this.selectedReferenceLibraryObjectsListNames,
    referenceGlobalObjects: this.selectedReferenceGlobalObjectsListNames,
    referenceGlobalSourceObjects: this.selectedReferenceGlobalSourceObjectsListNames,
    globalExternalObjects: this.selectedGlobalExternalObjectsListNames,
    exceptionQuery: this.exceptionExpressionDetails,
    tenantId: localStorage.getItem('dnsName') 
  };

   this.spinner.start();
   if (this.buttonName === 'Update' && this.uploadId) {
  requestData.exceptionQueryId = this.uploadId;
}

   this.commonService.createOrUpdateExceptionQuery(requestData).subscribe(
    res => {
       this.spinner.stop();
        if (res?.error) {
    this.snackbar.open(res.data || "Operation failed", "OK", { duration: 4000 });
    return;
  }

      let message = this.buttonName === 'Update'
        ? "Successfully record is updated"
        : "Successfully record is inserted";

      this.snackbar.open(message, "OK", { duration: 4000 });
      
      if (this.isCheckboxSelected && this.buttonName === 'Save') {
        this.validations_form.reset();
        this.exceptionExpressionDetails = "";
        this.selectedReferenceSourceObjectsListNames = "";
        this.selectedReferenceTargetObjectsListNames = "";
        this.selectedReferenceValueMapping = [];
        this.selectedReferenceLibraryObjectsListNames = "";
        this.selectedReferenceGlobalObjectsListNames = "";
        this.selectedReferenceGlobalSourceObjectsListNames = "";
        this.selectedGlobalExternalObjectsListNames = "";
    
        this.buttonName = 'Save';
        return;
        } else {
          this.dialogRef.close(res.data);
        }
      },
     

    err => {
      this.spinner.stop();
      this.snackbar.open("Failed to save Exception Query", "OK", { duration: 4000 });
    
    }
   )

      
    }

    populateEditData(row) {
  this.uploadId = row.exceptionQueryId;   

  this.validations_form.patchValue({
    orderId: row.orderId,
    exceptionType: row.exceptionType,
    executionType: row.executionType
  });

  this.selectedObjectMappingOrdeId = this.editData?.orderId;
  this.selectedReferenceSourceObjectsListNames = row.referenceSourceObject || "";
  this.selectedReferenceTargetObjectsListNames = row.referenceTransform || "";
  this.selectedReferenceLibraryObjectsListNames = row.referenceLibraryObjects || "";
  this.selectedReferenceGlobalObjectsListNames = row.referenceGlobalObjects || "";
  this.selectedReferenceGlobalSourceObjectsListNames = row.referenceGlobalSourceObjects || "";
  this.selectedGlobalExternalObjectsListNames = row.globalExternalObjects || "";

  if (row.referenceValueMapping) {
    this.selectedReferenceValueMapping = row.referenceValueMapping.split(',');
  }

  // Set exception SQL
  this.exceptionExpressionDetails = row.exceptionQuery || "";

  
}
onExpressionChange(value: string): void {
  console.log(value);
  
}

}
